module.exports = __webpack_public_path__ + "img/detail.ef694c49.svg";